import { render, staticRenderFns } from "./CustomerCorporateInvoicePreview.vue?vue&type=template&id=357c4038&scoped=true"
import script from "./CustomerCorporateInvoicePreview.vue?vue&type=script&lang=js"
export * from "./CustomerCorporateInvoicePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357c4038",
  null
  
)

export default component.exports